// START IMPORTS
// Core lib v1 imports
import {
  DarkWebHeader,
  DarkWebFindOutWhatElse,
  DarkWebBreaches,
  Faq,
  useSession,
  SerializedDarkWebBreach,
  useDarkWebReport,
  SearchData,
  ReportLoading,
} from '@ltvco/refresh-lib/v1';
// Vendor imports
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// App-specific imports
import { darkWebScanFaq } from './darkWebScanConstants';

// END IMPORTS

export function DarkWebScan() {
  // START HOOKS_AND_QUERIES
  const {
    session: { account },
  } = useSession();
  const navigate = useNavigate();
  const { data, isLoading } = useDarkWebReport({
    email: account?.account.user_info?.email as string,
  });
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    document.title = 'Dark Web Scan - PeopleLooker';
  }, []);
  // END EFFECTS

  // START EARLY_RETURNS
  if (isLoading) return <ReportLoading />;
  // END EARLY_RETURNS

  // START DERIVED_DATA_AND_UTILS
  const breaches = data?.data?.breaches;
  const updatedAt = data?.data?.rawData?.meta?.updated_at;
  // END DERIVED_DATA_AND_UTILS

  // START RENDER
  return (
    <>
      <DarkWebHeader updatedAt={updatedAt || ''} />
      <DarkWebBreaches breaches={breaches as SerializedDarkWebBreach[]} />
      <DarkWebFindOutWhatElse
        onSuccess={({ reportType, searchParams, permalink }: SearchData) => {
          const url = `/report/${reportType}?${searchParams}&permalink=${permalink}`;
          navigate(url);
        }}
      />
      <Faq faqItems={darkWebScanFaq} />
    </>
  );
  // END RENDER
}
